import * as styles from "./FieldGroup.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { ControlContext, makeControlContext } from "@frontend/contexts";

import {
  FieldContext,
  makeFieldContext,
  useFieldContext,
} from "./Field.context";
import type { FieldGroupProps } from "./Field.types";

export function FieldGroup({
  orientation,
  size,
  labelAlign,
  errorDisplay,
  className,
  ...props
}: FieldGroupProps): JSX.Element {
  const inherited = useFieldContext();
  const resolvedOrientation = orientation ?? inherited.orientation;
  const resolvedSize = size ?? inherited.size;
  const resolvedLabelAlign = labelAlign ?? inherited.labelAlign;
  const resolvedErrorDisplay = errorDisplay ?? inherited.errorDisplay;

  return (
    <FieldContext.Provider
      value={makeFieldContext({
        orientation: resolvedOrientation,
        size: resolvedSize,
        labelAlign: resolvedLabelAlign,
        errorDisplay: resolvedErrorDisplay,
        grouped: true,
      })}
    >
      <ControlContext.Provider
        value={makeControlContext({ size: resolvedSize })}
      >
        <div
          data-slot="field-group"
          className={clsx(
            styles.fieldGroup({
              orientation: resolvedOrientation,
              grouped: inherited.grouped,
            }),
            className,
          )}
          {...props}
        />
      </ControlContext.Provider>
    </FieldContext.Provider>
  );
}
